import { Chip } from '@billda/design-system';
import {
  CheckCircleIcon,
  ExitToAppIcon,
  MailOutlineIcon,
  RemoveCircleOutlineIcon,
} from '@billda/design-system';
import type { UserStatus } from '../../../api/userManagementApi';

interface UserStatusBadgeProps {
  status: UserStatus;
}

const statusConfig: Record<
  UserStatus,
  {
    label: string;
    color: 'default' | 'success' | 'warning' | 'error';
    icon: React.ReactElement;
  }
> = {
  Active: {
    label: 'Active',
    color: 'success',
    icon: <CheckCircleIcon aria-hidden="true" className="size-4" />,
  },
  InvitationSent: {
    label: 'Invitation Sent',
    color: 'warning',
    icon: <MailOutlineIcon aria-hidden="true" className="size-4" />,
  },
  Inactive: {
    label: 'Offboarded',
    color: 'default',
    icon: <RemoveCircleOutlineIcon aria-hidden="true" className="size-4" />,
  },
  Offboarding: {
    label: 'Offboarding',
    color: 'error',
    icon: <ExitToAppIcon aria-hidden="true" className="size-4" />,
  },
};

export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: status || 'Unknown',
    color: 'default' as const,
    icon: <RemoveCircleOutlineIcon aria-hidden="true" className="size-4" />,
  };

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="sm"
      icon={config.icon}
      className="font-medium"
    />
  );
}
